import React from "react";

function Resume() {
    return(
        <>
       <p className="d-flex justify-content-center"><span className="orange">Softwares/Platforms/Tools: </span> Express.js, Node.js, React, Handlebars.js, MySql, MongoDB, NoSql, GIT Command Line, jQuery, BootStrap, Bulma </p>
        <p className="d-flex justify-content-center"><span className="orange">Languages: </span> JavaScript, HTML5, CSS</p>
        <a className="d-flex justify-content-center" href="https://docs.google.com/document/d/1HI__JH_vX0-Pu2UJgHPSB4-ATW2cMafHkTGVG2BkVPo/edit?usp=sharing">Download a Copy Here!</a>
        <br></br>
        <div className="d-flex justify-content-center">
        <iframe src="https://docs.google.com/document/d/e/2PACX-1vSaWYeNsbf549nROSz_m7NBu5lqeWOmuR9ZPP5M108zcsPSqse_Dxe2ceN5Z1VLgfeahyYw_oeLlLQp/pub?embedded=true" 
            width='850' 
            height='400' 
            title='Margaret Saylor Resume'>Loading Resume…</iframe>
            </div>
            </>
    )
}

export default Resume